import { style } from '@do/walrus';
import styled from 'styled-components';
import newBrandDesignVars from './overwrite-vars.scss';

const NewCreditBanner = styled.div`
  width: 100%;
  background: ${newBrandDesignVars.green_lightest};
  padding: ${style.vars.whitespace.regular} ${style.vars.whitespace.large};
  border-bottom: ${style.vars.borderWidth.thin} solid
    ${newBrandDesignVars.green_darkest};
  position: fixed;
  display: flex;
  flex-direction: row;
  z-index: 100;
  margin-top: ${newBrandDesignVars.header_height} !important;

  span {
    margin-left: 14px;
  }

  @media screen and (max-width: 1150px) {
    flex-direction: column;

    span {
      margin-left: 0;
    }
  }

  strong {
    font-family: 'JetBrains Mono', sans-serif;
    font-size: ${style.vars.fontSize.small};
    line-height: ${style.vars.height.xsmall};
    font-weight: 800;
    white-space: nowrap;
    letter-spacing: 1px;
    font-feature-settings: 'ordn' on, 'case' on;
  }
`;

export default NewCreditBanner;
